// The site is prerendered with Puppeteer, which runs effects and snapshots the
// resulting DOM. React hydration then compares that snapshot against the
// client's first render. Effects that measure the DOM and feed the result back
// into the markup (heights, overflow, mounting client-only widgets) must be
// skipped during prerendering, otherwise the snapshot contains values the
// client's initial render does not have and hydration fails.
//
// The prerenderer sets window.__PRERENDER_INJECTED (via its `inject` option in
// scripts/prerender.js) before any app code runs; real visitors never have it.
export const isPrerendering = (): boolean => typeof window !== 'undefined' && '__PRERENDER_INJECTED' in window;
